"use client";

import { MDXContent } from "@content-collections/mdx/react";
import { cn } from "@ui/lib";
import { mdxComponents } from "../utils/mdx-components";

export function PostContent({
	content,
	className,
}: {
	content: string;
	className?: string;
}) {
	return (
		<div
			className={cn(
				"prose dark:prose-invert mx-auto mt-6 max-w-2xl",
				className,
			)}
		>
			<MDXContent code={content} components={mdxComponents} />
		</div>
	);
}
